// core
import React from "react";

// components
import Icon from "../Icon/Icon";

// styles
import cx from "classnames";
import styles from "./StarRating.module.scss";

interface IStarRating {
    rating: number;
    maxRating: number;
    size?: number;
    id?: string;
    notRatedText?: string;
    alignment?: "start" | "center" | "end";
}

const StarRating: React.FC<IStarRating> = (props) => {
    const { id, rating, maxRating } = props;
    const size = props.size || 14;
    const alignment = props.alignment || "center";

    const number = props.rating.toFixed(1);

    const hasNoRating = !rating || rating <= 0;

    const fullStars = Math.trunc(rating);
    const halfStar = rating % 1 > 0;

    return (
        <div
            className={cx("layout-flex-column", styles["container"], {
                [styles["start"]]: alignment === "start",
                [styles["center"]]: alignment === "center",
                [styles["end"]]: alignment === "end"
            })}>
            <div
                className={cx(styles["stars"], "layout-flex-row", {
                    ["layout-hidden"]: hasNoRating
                })}
                style={{
                    width: size * maxRating
                }}>
                {fullStars > 0 &&
                    [...new Array(fullStars)]
                        .map((acc, i) => i + 1)
                        .map((index: number) => (
                            <Icon
                                key={`${id}-${index}`}
                                height={`${size}px`}
                                id="YellowStar"
                            />
                        ))}
                {halfStar && <Icon height={`${size}px`} id="YellowStarHalf" />}
            </div>
            <span className="text-font-size-xs">
                {hasNoRating ? props.notRatedText || "Not rated" : number}
            </span>
        </div>
    );
};

export default StarRating;
